import React, { useState } from 'react';
import { Checkbox } from '@mui/material';
import { BaseCellRendererProps } from '../Common/CellRendererProps';

export const BooleanCellRenderer: React.FC<BaseCellRendererProps> = (props) => {
  const [value, setValue] = useState<boolean>(props.value || false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked;
    setValue(newValue);
    props.node.setDataValue(props.column.colId, newValue);
    
    if (props.context?.onCellUpdate) {
      props.context.onCellUpdate(props.data, props.column.colId, newValue);
    }
  };

  return (
    <Checkbox 
      checked={value} 
      onChange={handleChange} 
      size="small" 
    />
  );
};